import { Box, Typography } from '@mui/material';

const DrawerFormActionSummary = ({
  label,
  value,
  sx = {},
  labelSx = {},
  valueSx = {},
}) => (
  <Box sx={{ minWidth: 0, ...sx }}>
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        color: 'text.secondary',
        fontWeight: 800,
        lineHeight: 1.2,
        ...labelSx,
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="h6"
      sx={{
        color: 'primary.main',
        fontWeight: 800,
        fontSize: { xs: '1.05rem', sm: '1.2rem' },
        lineHeight: 1.15,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...valueSx,
      }}
      title={String(value || '-')}
    >
      {value || '-'}
    </Typography>
  </Box>
);

export default DrawerFormActionSummary;
